import React, { useEffect, useState } from "react";
import Style from "./DeliveryCurrentRequest.module.css";
import { Divider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfo,
  faMapPin,
  faMoneyBillWave,
  faPhone,
} from "@fortawesome/fontawesome-free-solid";
import { separate } from "../../../../Seprate/Seprate";
import { errorToast, succToast } from "../../../../Toast/Toast";
import {
  checkDeliverRequestApi,
  userCancelDeliveryApi,
  userPayDeliveryApi,
} from "../../../../Api/DeliveryServices";
import moment from "moment-jalaali";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
const DeliveryCurrentRequest = () => {
  const [TravelsState, setTravelsState] = useState();
  const [loadingState, setLoadingState] = useState(false);
  const MINUTE_MS = 6000;

  useEffect(() => {
    getCurrentTravelData();
    const interval = setInterval(() => {
      getCurrentTravelData();
    }, MINUTE_MS);
    return () => clearInterval(interval);
  }, []);

  const getCurrentTravelData = () => {
    checkDeliverRequestApi((succ, res) => {
      if (succ) {
        if (res.staus === -1) {
          console.log(res.message);
        } else {
          setTravelsState(res.request);
        }
      } else {
        console.log(res);
      }
    });
  };

  const payTaxiHandler = (id) => {
    setLoadingState(true);
    let infoData = {
      id: id,
      payment_type: "pgw",
    };
    userPayDeliveryApi(infoData, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          window.open(res.link, "_self");
          setLoadingState(false);
        } else {
          errorToast(res.message);
          setLoadingState(false);
        }
      } else {
        console.error(res);
        setLoadingState(false);
      }
    });
  };
  const cancelRequestHanlder = (id) => {
    setLoadingState(true);
    let info = {
      id:id,
      cause: "",
    };
    userCancelDeliveryApi(info, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          setLoadingState(false);
          errorToast(res.message);
        } else {
          succToast("درخواست شما لغو شد!");
          setLoadingState(false);
        }
      } else {
        console.error(res);
        setLoadingState(false);
      }
    });
  };
  return (
    <div className={Style.mainComponentHolder}>
      {TravelsState === undefined ? (
        <p>درحال دریافت اطلاعات....</p>
      ) : TravelsState.length === 0 ? (
        <p>درخواستی یافت نشد!</p>
      ) : (
        TravelsState.map((item) => {
          return (
            <div key={item.id} className={Style.ComponentHolder}>
              <div className={Style.DateHolder}>
                  <FontAwesomeIcon icon={faCalendar} color="#d00d8f" />
                  <p>
                    {moment
                      .unix(parseInt(item.end_date??item.request_date))
                      .format("jYYYY/jM/jD--HH:mm")}
                  </p>
                </div>
              <section className={Style.PartHolder}>
                <Divider>مشخصات</Divider>
                <div className={Style.userLocationInfo}>
                  <p>
                    <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
                    مبدا:{item?.routs[0]?.description}
                  </p>
                  <div>
                    <strong>نام و نام خانوادگی: </strong>
                    <span>{item?.routs[0].name}</span>
                  </div>
                  <div>
                    <strong>شماره تماس: </strong>
                    <span style={{ color: "#d00d8f" }}>
                      {item?.routs[0].phone}
                    </span>
                  </div>
                  {item?.routs[0]?.routes_description && (
                    <div>
                      <strong>توضیحات: </strong>
                      <span>
                        {item?.routs[0]?.routes_description}
                      </span>
                    </div>
                  )}
                </div>
                <div className={Style.userLocationInfo}>
                  <p>
                    <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
                    مقصد:{item?.routs[1]?.description}
                  </p>
                  <div>
                    <strong>گیرنده: </strong>
                    <span>{item?.routs[1].name}</span>
                  </div>
                  <div>
                    <strong>شماره تماس: </strong>
                    <span style={{ color: "#d00d8f" }}>
                      {item?.routs[1].phone}
                    </span>
                  </div>
                  {item?.routs[1]?.routes_description && (
                    <div>
                      <strong>توضیحات: </strong>
                      <span>
                        {item?.routs[1]?.routes_description}
                      </span>
                    </div>
                  )}
                </div>

                {item?.routs[2] && (
                  <div className={Style.userLocationInfo}>
                    <p>
                      <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
                      مقصد دوم:{item?.routs[2]?.description}
                    </p>
                    <div>
                      <strong>گیرنده دوم: </strong>
                      <span>{item?.routs[2].name}</span>
                    </div>
                    <div>
                      <strong>شماره تماس: </strong>
                      <span style={{ color: "#d00d8f" }}>
                        {item?.routs[2].phone}
                      </span>
                    </div>
                    {item?.routs[2]?.routes_description && (
                      <div>
                        <strong>توضیحات: </strong>
                        <span>
                          {item?.routs[2]?.routes_description}
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </section>
              {item?.status !== "0" ? (
                <section className={Style.PartHolder}>
                  <Divider>اطلاعات پیک</Divider>
                  <div className={Style.DriverInfoHolder}>
                    <div className={Style.ProfileHolder}>
                      <img
                        src={`https://cdn.barest.ir/deliver/photo/${item?.driver.photo}.jpg`}
                        alt=""
                      />
                    </div>
                    <div className={Style.DriverInfoPartOne}>
                      <h6>{item?.driver.name}</h6>
                      <p>
                        {item?.driver.vehicle_model}{" "}
                        {item?.driver.vehicle_color}
                      </p>
                    </div>
                    <div className={Style.DriverInfoParttwo}>
                      <p className={Style.CarPlateHolder}>
                        {item?.driver.vehicle_plate}
                      </p>
                      <a
                        href={`tel:${item?.driver.phone}`}
                        className={Style.DriverPhoneHolder}
                      >
                        <FontAwesomeIcon icon={faPhone} /> تماس با راننده
                      </a>
                    </div>
                  </div>
                </section>
              ) : null}
              <section className={Style.PartHolder}>
                <Divider>هزینه</Divider>
                <div className={Style.PricePartHolder}>
                  <p>
                    <FontAwesomeIcon icon={faMoneyBillWave} color="#d00d8f" /> 
                    <span style={{ color: "green" }}>
                      مبلغ:{separate(item?.delivery)} تومان
                    </span>
                  </p>
                  {item?.paid !== "0" ? (
                    <p style={{ fontSize: "0.7rem", color: "green" }}>
                      پرداخت شده!
                    </p>
                  ) : (
                    <button
                      onClick={()=>payTaxiHandler(item.id)}
                      disabled={loadingState}
                      style={
                        loadingState
                          ? {
                              background: "#fff",
                              color: "rgb(143, 9, 76)",
                              borderColor: "rgb(143, 9, 76)",
                            }
                          : null
                      }
                    >
                      پرداخت
                    </button>
                  )}
                </div>
              </section>
              <section className={Style.PartHolder}>
                <Divider>وضعیت درخواست</Divider>
                <div className={Style.PricePartHolder}>
                  <p className={Style.RequestStatusHolder}>
                    <FontAwesomeIcon icon={faInfo} color="#d00d8f" /> 
                    {item?.status === "0"
                      ? "منتظر تایید راننده"
                      : item?.status === "1"
                      ? "راننده در مسیر مبدأ"
                      : item?.status === "2"
                      ? "راننده در مبدأ است!"
                      : item?.status === "3"
                      ? "در مسیر مقصد!"
                      : null}
                  </p>
                </div>
                {item?.status === "0" ? (
                  <button
                    className={Style.cancelRequest}
                    onClick={()=>cancelRequestHanlder(item.id)}
                    disabled={loadingState}
                  >
                    {loadingState ? "لطفا صبرکنید..." : "لغو درخواست"}
                  </button>
                ) : null}
              </section>
            </div>
          );
        })
      )}
    </div>
  );
};

export default DeliveryCurrentRequest;
